import moment from 'moment-timezone';
import { Agent } from './agent';
import { Attachment } from './attachment';
import { BillSubmissionMethod, EnterpriseBillSubmissionMethod } from './bill-submission-method';
import { EnterpriseUserNotificationCategoryRecipient } from './enterprise-user-notification-category-recipient';
import { User } from './user';
import { UserNotificationCategory } from './user-notification-category';

export class Enterprise {
	public id: number;
	public name: string;
	public createdAt: Date;
	public updatedAt: Date;
	public targetEnergyPortalBudgetMonth: number;
	public isActive: boolean;
	public enterpriseDomainAlias: string;
	public darkBackgroundsLogoAttachmentId: string;
	public lightBackgroundsLogoAttachmentId: string;

	public logins: User[];
	public agents: Agent[];
	public commissionProfiles: Agent[];
	public userNotificationCategories: UserNotificationCategory[];
	public userNotificationCategoryRecipients: EnterpriseUserNotificationCategoryRecipient[];
	public billSubmissionMethods: BillSubmissionMethod[];
	public enterpriseBillSubmissionMethods: EnterpriseBillSubmissionMethod[];
	public darkBackgroundsLogoAttachment: Attachment;
	public lightBackgroundsLogoAttachment: Attachment;

	public darkDisplayLogoAttachment: Attachment; // graphql alias property
	public lightDisplayLogoAttachment: Attachment; // graphql alias property

	constructor(enterprise?: Subset<Enterprise>) {
		Object.assign(this, enterprise);

		this.createdAt = this.createdAt ? new Date(moment(this.createdAt).format('MMM DD, YYYY hh:mm:ss a')) : this.createdAt;
		this.updatedAt = this.updatedAt ? new Date(moment(this.updatedAt).format('MMM DD, YYYY hh:mm:ss a')) : this.updatedAt;
		this.logins = this.logins ? this.logins.map(u => new User(u)) : this.logins;
		this.agents = this.agents ? this.agents.map(a => new Agent(a)) : this.agents;
		this.commissionProfiles = this.commissionProfiles ? this.commissionProfiles.map(a => new Agent(a)) : this.commissionProfiles;
		this.userNotificationCategories = this.userNotificationCategories
			? this.userNotificationCategories.map(u => new UserNotificationCategory(u))
			: this.userNotificationCategories;
		this.userNotificationCategoryRecipients = this.userNotificationCategoryRecipients
			? this.userNotificationCategoryRecipients.map(recipient => Object.assign(new EnterpriseUserNotificationCategoryRecipient(), recipient))
			: this.userNotificationCategoryRecipients;
		this.billSubmissionMethods = this.billSubmissionMethods
			? this.billSubmissionMethods.map(b => new BillSubmissionMethod(b))
			: this.billSubmissionMethods;
		this.enterpriseBillSubmissionMethods = this.enterpriseBillSubmissionMethods
			? this.enterpriseBillSubmissionMethods.map(e => new EnterpriseBillSubmissionMethod(e))
			: this.enterpriseBillSubmissionMethods;
	}
}
